export default __webpack_public_path__ + "static/media/singlebed4.a8290866.jpg";